import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as styles from '../../styles/checkbox';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Checkbox = _ref => {
  var type = _ref.type,
    size = _ref.size,
    inputProps = _ref.inputProps,
    checkboxWrapperFlags = _ref.checkboxWrapperFlags,
    labelContent = _ref.labelContent,
    inputRef = _ref.inputRef,
    indeterminate = _ref.indeterminate;
  var checkboxRef = useRef();
  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      checkboxRef.current.indeterminate = indeterminate;
    } else {
      checkboxRef.current.indeterminate = false;
    }
  }, [checkboxRef, indeterminate]);
  var controlShade = ___EmotionJSX("div", {
    className: "domain-checkbox_control-shade",
    css: styles.controlShade
  }, ___EmotionJSX("span", {
    key: "check",
    className: "domain-icon domain-icon--check",
    css: /*#__PURE__*/_css([styles.icon, styles.check(checkboxWrapperFlags)])
  }), ___EmotionJSX("span", {
    key: "indeterminate",
    className: "domain-icon domain-icon--indeterminate",
    css: /*#__PURE__*/_css([styles.icon, styles.indeterminate(checkboxWrapperFlags)])
  }));
  return ___EmotionJSX("div", {
    className: classnames('domain-checkbox__input', {
      ["is-".concat(size)]: size !== 'default'
    }, "domain-checkbox--".concat(type)),
    css: styles.input(checkboxWrapperFlags, type)
  }, ___EmotionJSX("input", _extends({
    ref: element => {
      if (typeof inputRef === 'function') {
        inputRef(element);
      } else if (typeof inputRef === 'object') {
        // eslint-disable-next-line no-param-reassign
        inputRef.current = element;
      }
      checkboxRef.current = element;
    },
    className: "domain-checkbox__checkbox",
    css: styles.checkbox,
    type: "checkbox"
  }, inputProps)), ___EmotionJSX("div", {
    className: "domain-checkbox__control-indicator",
    css: styles.controlIndicator(checkboxWrapperFlags, type)
  }, type === 'checkbox' && controlShade, type === 'toggle' && ___EmotionJSX("span", {
    className: "domain-checkbox__control-switch",
    css: styles.controlSwitch
  }), (type === 'tile' || type === 'tile-checkbox') && ___EmotionJSX("span", {
    className: "domain-checkbox__control-tile",
    css: styles.controlTile
  }, type === 'tile-checkbox' && ___EmotionJSX("div", {
    className: "domain-checkbox__control-indicator",
    css: styles.controlIndicator(checkboxWrapperFlags, 'checkbox')
  }, controlShade), labelContent)));
};
Checkbox.propTypes = {
  type: PropTypes.oneOf(['checkbox', 'toggle', 'tile', 'tile-checkbox']),
  size: PropTypes.oneOf(['large', 'default']),
  indeterminate: PropTypes.bool,
  inputProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func
  }).isRequired,
  labelContent: PropTypes.node.isRequired,
  checkboxWrapperFlags: PropTypes.shape({
    isFullWidth: PropTypes.bool,
    isLabelLeft: PropTypes.bool,
    isToggle: PropTypes.bool,
    size: PropTypes.string,
    isTile: PropTypes.bool,
    isTileCheckbox: PropTypes.bool
  }),
  inputRef: PropTypes.oneOfType([PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  PropTypes.shape({
    current: PropTypes.any
  })])
};
Checkbox.defaultProps = {
  type: 'checkbox',
  indeterminate: false,
  size: 'default',
  checkboxWrapperFlags: {},
  inputRef: undefined
};
export default Checkbox;